import { BackgroundColor } from "../../components/atoms/SubLayout";
import enhanceHomePage from "../../hocs/enhanceHomePage";
import { UpdatePage } from "./UpdatePage";

export const MultiSectionBatchesUpdateDrillPage = enhanceHomePage(UpdatePage, {
  title: "校舎横断操作",
  backgroundColor: BackgroundColor.Gray,
});
